// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".support-header{font-size:16px;font-weight:700}.remaining-chars{margin-top:-15px}", ""]);
// Exports
module.exports = exports;
